'use strict';

var angular = require('angular');
var _ = require('lodash');
var CreateStrategyPopoverDirective = function CreateStrategyPopoverDirective(strategyConstants, featureToggleService) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/create-strategy-popover.html'),
    scope: {
      isAlertsTab: '='
    },
    link: function link($scope) {
      function getStrategyType() {
        return $scope.hideTemplateStrategies ? strategyConstants.StrategyType.CUSTOM : strategyConstants.StrategyType.TEMPLATE;
      }
      $scope.hideTemplateStrategies = $scope.isAlertsTab || featureToggleService.isEnabled('SERVICE_CLASS_CONTROL');
      $scope.strategyType = getStrategyType();
      $scope.strategyTypes = _.clone(strategyConstants.StrategyType);
      $scope.createStrategy = function () {
        $scope.$emit('strategy:createStrategy', $scope.strategyType);
      };
      $scope.dropDownClicked = function (e) {
        e.stopPropagation();
        if (angular.element(e.target).hasClass('cancel-drop-down')) {
          angular.element('.toolbar-dropdown-menu').parent().removeClass('open');
        }
      };
    }
  };
};
CreateStrategyPopoverDirective.$inject = ['StrategyConstants', 'FeatureToggleService'];
module.exports = CreateStrategyPopoverDirective;